export default {
  payPalPartner: 'PayPal Holdings, Inc.',
  payPal: 'PayPal Business Loan',
  loan: 'Loan',
};
